import { withActions } from '@/modules/shared/hocs/withActions'
import { withRoles } from 'app/containers/administration/withRoles'
import { getCompanies } from 'app/actions/company'
import { getUserInfo } from 'app/actions/user'
import PostLogin, {
  PostLoginDispatchProps,
} from 'app/components/login/postLogin'
import { CompanyDetailsModel } from 'app/models/companyDetailsModel'
import { enterCompany } from 'app/actions/companySelection'

export function mapDispatchToProps(): Omit<PostLoginDispatchProps, 'getRoles'> {
  return {
    getUserInfo: (userId?: string) => getUserInfo(userId),
    getCompanies: () => getCompanies(),
    enterCompany: (company: CompanyDetailsModel) => enterCompany(company),
  }
}

// `getRoles` dostarcza react-query przez ten sam klucz co panel administracyjny.
export default withRoles(withActions(PostLogin as any, mapDispatchToProps()))
